import {
  Button,
  Checkbox,
  EmptyState,
  Icons,
  Intent,
  Spinner
} from 'construct-ui';
import TreeComponent from '../../components/treeview/tree.component';
import SEAOGoodMovementModel from '../../models/retail-asset-management/seao-goods-movement.model';
import { addSEAOHierachyDetail, getSEAOHierachyTreeByLevel } from '../../models/retail-asset-management/seao-posm-master.model';
import ViewBase from '../view-base.view';

/**
 *
 *
 * @author cmc.nkhiep
 */
const hierachyMap = [
  'main',
  'goodsType',
  'division',
  'model',
  'basicModel',
  'movementType',
  'storageLocation',
  'warehouse',
];

export default function SEAOPOSMLevelHierarchy() {
  ViewBase.call(this);

  let isHierachyLoading = false;
  const LIST_HEIGHT = '700px';

  let maxCurrentLevel = SEAOGoodMovementModel.isFromPOSMGoodMovement ? 1 : 5;
  const DEFAULT_FIELD_VALUES = {
    parentName: '',
    code: '',
    name: '',
    description: '',
    etcInfo: '',
    hierarchyLevel: 1,
    active: true,
    snFlag: true
  };

  let isTreeLoading = false;
  let isDetailsLoading = false;
  let hierarchyTree = [];
  let hierarchyDetail = structuredClone(DEFAULT_FIELD_VALUES);

  const handleBack = () => { m.route.set('/seao/posm-goods-movement'); }

  const onSave = (e) => {
    e.preventDefault();
    if (!this.validateForm(e)) {
      return false;
    }
    isHierachyLoading = true;
    const payload = {
      Name: hierarchyDetail.name,
      Description: hierarchyDetail.description,
      Level: hierarchyDetail.hierarchyLevel,
      SNFlag: hierarchyDetail.snFlag,
      Active: hierarchyDetail.active,
      ParentId: hierarchyDetail.parentId,
      Parentcode: hierarchyDetail.parentCode,
      Controlcode: hierarchyDetail.code
        ? hierarchyDetail.code
        : hierarchyDetail.name
    }
    addSEAOHierachyDetail(payload)
      .then((data) => {
        isHierachyLoading = false;
        if (data[0].transStatus != 'SUCCESS') {
          this.showErrorMessage(data[0].message, null, null);
        } else {
          this.showMessage(this.getText('EM00000004', 'Success'), null, handleBack);
        }
      })
      .catch((err) => {
        isHierachyLoading = false;
        this.showErrorMessage(err, null, null);
      });
  };

  const handleOninput = (e, propName) => {
    hierarchyDetail[propName] = e.target.value;
  };

  const getHierarchyTree = (hierarchyType) => {
    isTreeLoading = true;
    hierarchyTree = createHierarchyTree(
      SEAOGoodMovementModel.getMovementDetail(),
      1,
      null
    );
    isTreeLoading = false;
  };

  const flattenArray = (arr) =>
    arr.flatMap((item) => {
      let { children, level, ...rest } = item;
      return [{ hierarchyLevel: level, ...rest }, ...flattenArray(children)];
    });

  const getHierarchyDetail = (hierarchyCode) => {
    isDetailsLoading = true;
    let hierachyArray = hierarchyTree;
    hierarchyDetail = flattenArray(hierachyArray).find((item) => item.code === hierarchyCode);
    isDetailsLoading = false;
    m.redraw();
  };

  const showLevelLabel = (level) =>
    `${SEAOGoodMovementModel.isFromPOSMGoodMovement && hierarchyDetail?.hierarchyLevel == maxCurrentLevel ? this.getText('LT00001335', 'New') : ''} ${this.getText(SEAOGoodMovementModel.SEAOHierachyLabel[level - 1][1], SEAOGoodMovementModel.SEAOHierachyLabel[level - 1][0])}`

  function createHierarchyTree(movementDetail, currentLevel, parent) {
    let result = [];
    let type = hierachyMap[currentLevel - 1];
    if (!type || !movementDetail[type]) {
      return result;
    }
    if (currentLevel > maxCurrentLevel) {
      maxCurrentLevel = currentLevel;
    }

    result[result.length] = {
      id: movementDetail[type].id,
      code: movementDetail[type].code,
      name: movementDetail[type].name
        ? movementDetail[type].name
        : showLevelLabel(currentLevel),
      hierarchyLevel: currentLevel,
      parentId: parent ? parent.id : 0,
      parentCode: parent ? parent.code : '0',
      parentName: parent ? parent.name : '',
      active: movementDetail[type].active != null ? movementDetail[type].active : true,
      snFlag: movementDetail[type].snFlag != null ? movementDetail[type].snFlag : true,
      children: movementDetail[type].code
        ? createHierarchyTree(
          movementDetail,
          currentLevel + 1,
          movementDetail[type].code ? movementDetail[type] : null
        )
        : [],
    };

    return result;
  }
  return {
    oninit: () => {
      if (!SEAOGoodMovementModel.isFromPOSMGoodMovement) {
        getSEAOHierachyTreeByLevel(1, 5).then((data) => {
          hierarchyTree = data
        })
      } else {
        getHierarchyTree();
      }
    },
    onremove: () => {
      SEAOGoodMovementModel.isGoingtoHierachy = false;
      SEAOGoodMovementModel.isFromPOSMGoodMovement = false;
    },
    view: () => [
      isHierachyLoading &&
      m(Spinner, { fill: true, background: true, active: true }),
      m(
        '.row.g-1',
        { style: { height: LIST_HEIGHT } },
        // LEFT PANE
        m('.col-4.h-100',
          m('.card.h-100',
            m('.card-header.d-flex.justify-content-between.gap-2',
              m('.h2',
                SEAOGoodMovementModel.isFromPOSMGoodMovement &&
                m('i.bi.bi-arrow-left.cursor-pointer', {
                  onclick: handleBack
                }),
                this.getText('LT00001339', 'Retail Asset Level Hierarchy')
              ),
            ),
            m('.card-body.h-100.overflow-auto',
              m('.d-flex.h-100.flex-column.gap-3',
                m('.flex-fill.overflow-auto.position-relative',
                  hierarchyTree && hierarchyTree.length > 0
                    ? m(TreeComponent, {
                      isOpenTheLastLevel: SEAOGoodMovementModel.isFromPOSMGoodMovement,
                      getNodeDetail: getHierarchyDetail,
                      items: hierarchyTree,
                      multiple: true,
                      globalOnClick: (value) => {
                        getHierarchyDetail(value);
                      },
                    })
                    : m(EmptyState, {
                      class: 'placeholder-text-color',
                      icon: Icons.ARCHIVE,
                      content: this.getText('LT00000317', 'No results found'),
                      fill: true,
                    })
                ),
                isTreeLoading &&
                m(Spinner, { fill: true, background: true, active: true })
              )
            )
          )
        ),

        // RIGHT PANE
        m('.col-8',
          m('.card',
            m('.card-header',
              m('.h2', showLevelLabel(hierarchyDetail?.hierarchyLevel))
            ),
            m('.card-body',
              m('form.row.g-3.needs-validation[novalidate]',
                { onsubmit: onSave },
                hierarchyDetail?.hierarchyLevel != 1 && [
                  m('.col-4.position-relative',
                    m('label.form-label',
                      this.getText('LT00000777', 'Parent Name')
                    ),
                    m('input.form-control', {
                      disabled: true,
                      type: 'text',
                      value: hierarchyDetail?.parentName,
                    })
                  ),
                  m('.col-8'),
                ],
                m('.col-4.position-relative',
                  m('label.form-label.mandatory',
                    this.getText('LT00000011', 'Name')
                  ),
                  m('input.form-control', {
                    disabled: !SEAOGoodMovementModel.isFromPOSMGoodMovement || hierarchyDetail?.hierarchyLevel < maxCurrentLevel,
                    type: 'text',
                    required: true,
                    maxlength: 100,
                    id: '#name',
                    value: hierarchyDetail?.name,
                    oninput: (e) => {
                      handleOninput(e, 'name');
                    },
                  }),
                  m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields'))
                ),
                m('.col-4.position-relative',
                  (hierarchyDetail?.hierarchyLevel == 2 || hierarchyDetail?.hierarchyLevel == 3) &&
                  [
                    m('label.form-label.mandatory', this.getText('LT00000778', 'Code')),
                    m('input.form-control', {
                      disabled: hierarchyDetail?.hierarchyLevel < maxCurrentLevel,
                      type: 'text',
                      required: true,
                      maxlength: 3,
                      value: hierarchyDetail?.code,
                      id: '#code',
                      oninput: (e) => {
                        handleOninput(e, 'code');
                      },
                    }),
                    m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields')),
                  ]
                ),

                m('.col-4'),
                hierarchyDetail?.hierarchyLevel == 5 && [
                  m('.col-4',
                    m('label.form-label.pe-2[for=goodstype]',
                      this.getText('LT00001338', 'Serial Number')
                    ),
                    m(Checkbox, {
                      disabled: !SEAOGoodMovementModel.isFromPOSMGoodMovement || hierarchyDetail?.hierarchyLevel < maxCurrentLevel,
                      checked: hierarchyDetail?.snFlag,
                      onchange: (e) => {
                        hierarchyDetail.snFlag = e.target.checked;
                      }
                    })
                  ),
                ],
                m('.col-2',
                  m('.d-flex.flex-column.h-100',
                    m('label.form-label', this.getText('LT00000015', 'Status')),
                    m('.d-flex.flex-fill.align-items-center',
                      m('div',
                        hierarchyDetail?.active
                          ? m(
                            '.badge.rounded-pill.green-bg-status',
                            this.getText('LT00000025', 'Active')
                          )
                          : m(
                            '.badge.rounded-pill.grey-bg-status',
                            this.getText('LT00000029', 'Inactive')
                          )
                      )
                    )
                  )
                ),
                m('.col.d-flex.justify-content-end.align-items-end.gap-2',
                  m(Button, {
                    disabled: !SEAOGoodMovementModel.isFromPOSMGoodMovement || hierarchyDetail?.hierarchyLevel < maxCurrentLevel,
                    type: 'submit',
                    intent: Intent.PRIMARY,
                    label: this.getText('LT00000022', 'Save'),
                  }),
                  m(Button, {
                    label: this.getText('LT00000021', 'Close'),
                    onclick: handleBack,
                  })
                  // m(Button, {
                  //   iconLeft: Icons.PLUS,
                  //   intent: Intent.PRIMARY,
                  //   label: this.getText('LT00001291', 'New Division'),
                  //   onclick: () => {
                  //   }
                  // }),
                  // m(Button, {
                  //   iconLeft: Icons.EDIT_2,
                  //   intent: Intent.POSITIVE,
                  //   label: this.getText('', 'Edit'),
                  //   onclick: () => {
                  //   }
                  // }),
                  // m(Button, {
                  //   iconLeft: Icons.X,
                  //   intent: Intent.NEGATIVE,
                  //   label: this.getText('', 'Delete'),
                  //   onclick: () => {
                  //   }
                  // })
                )
              )
            ),
            isDetailsLoading &&
            m(Spinner, { active: true, fill: true, background: true })
          )
        )
      ),
      this.getBaseViews(),
    ],
  };
}
